var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { attrs: { xs6: "", "ma-1": "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.invoicingUrl } },
                    [
                      _c("v-icon", [_vm._v("attach_money")]),
                      _vm._v(" Invoicing"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.receiptsUrl } },
                    [
                      _c("v-icon", [_vm._v("attach_money")]),
                      _vm._v(" Receipts"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.refundsUrl } },
                    [
                      _c("v-icon", [_vm._v("attach_money")]),
                      _vm._v(" Refunds & Adjustments"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.vouchersUrl } },
                    [
                      _c("v-icon", [_vm._v("card_giftcard")]),
                      _vm._v(" Vouchers"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.reportsUrl } },
                    [_c("v-icon", [_vm._v("show_chart")]), _vm._v(" Reports")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { href: _vm.filesUrl, disabled: "" } },
                    [_c("v-icon", [_vm._v("download")]), _vm._v(" Files")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }